<template>
	<div>
		<button @click="click" :title="_traducao('global', 'voltar')" class="btn btn-default pull-right btn-lg">
			<i class="icon-left botao_i" aria-hidden="true"></i>
		</button>
	</div>
</template>

<script>
export default {
	methods: {
		click() {
			this.$emit('click')
		}
	}
}
</script>

<style scoped>
.botao_i {
	font-size: 18px;
}
</style>
